import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Settings from "../providers/settings.provider";
import Filter from "../model/filter.model";
import Customer from "../model/customer.model";

export var Name = 'Customers';

export class CustomersFilter extends Filter {

    static load = function (name) {
        return Filter.load(name, CustomersFilter);
    };

    constructor(data) {
        super(data);

        this.sortBy = 'name';
        this.search = null;
        this.customerId = null;

        if (data) {
            Object.assign(this, data);
        }
    }

    active() {
        if (this.search != null
            || this.customerId != null) {

            return true;
        }

        return false;
    }

    reset() {
        super.reset();
        this.sortBy = 'name';
        this.search = null;
        this.customerId = null;
    }
}

export class Customers extends Service {
    static Resources = Name;
    static $inject = ['$q', 'Restangular', 'settings'];

    create() {
        // NOOP.
    }

    get(customerId) {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('customer', customerId)
            .get()
            .then((customerData) => {
                defer.resolve(this.Restangular.copy(new Customer(customerData)));
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }

    find(customerFilter) {
        var defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .all('customers')
            .post(customerFilter)
            .then((response) => {
                response.data = response.data.map((customerData) => {
                    return this.Restangular.copy(new Customer(customerData));
                });

                defer.resolve(response);
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }

}

var CustomersModule = Angular.module('customers-service', ['restangular', Settings.name]);

new Loader(CustomersModule)
    .load(Customers);

export default CustomersModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/customers.service.js